import React from "react";
import { Box, Chip, Typography, Autocomplete, TextField } from "@mui/material";

const TagSelectSection = ({
  formData,
  setFormData,
  dietaryOptions,
  allergenOptions,
  formErrors,
}) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Allergens & Dietary Tags
      </Typography>

      {/* Dietary Tags */}
      <Autocomplete
        multiple
        options={dietaryOptions}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        value={formData.dietaryTags || []}
        onChange={(e, newValue) =>
          setFormData({ ...formData, dietaryTags: newValue })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Dietary Tags"
            placeholder="Select..."
            error={!!formErrors?.dietaryTags}
            helperText={formErrors?.dietaryTags}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option.label}
              style={{ backgroundColor: `#${option.color}`, color: "#fff" }}
              {...getTagProps({ index })}
            />
          ))
        }
        sx={{ mb: 2 }}
      />

      {/* Allergens */}
      <Autocomplete
        multiple
        options={allergenOptions}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        value={formData.allergens || []}
        onChange={(e, newValue) =>
          setFormData({ ...formData, allergens: newValue })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Allergens"
            placeholder="Select..."
            error={!!formErrors?.allergens}
            helperText={formErrors?.allergens}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option.name}
              color="warning"
              {...getTagProps({ index })}
            />
          ))
        }
      />
    </Box>
  );
};

export default TagSelectSection;
